import { observable, action, computed, toJS, reaction } from 'mobx'
import
Payment,
{
    CreatePaymentQuestionnaireModel, createStub,
} from '../Model/Payment'
import ActionsLocalService from '../Services/ActionsLocalService'
import { ExportType } from './ExportStore'

export default class PaymentsStore {
    @observable
    private createPaymentQuestionnaireModel: CreatePaymentQuestionnaireModel | null

    @observable
    private item: Payment | null

    @observable
    private list: Array<Payment>

    @observable
    private pageCount: number = 0

    private static _instance: PaymentsStore

    private constructor() {
        this.list = []

        reaction(
            () => this.list,
            _ => {
                let data = createStub(this.list)
                ActionsLocalService.getInstance().setExportData(ExportType.Payments, data)
            }
        )
    }

    public static getInstance(): PaymentsStore {
        return this._instance || (this._instance = new this())
    }

    @action.bound
    setList(list: Array<Payment>): void {
        this.list = list
    }

    @computed
    get getList(): Array<Payment> {
        return toJS(this.list)
    }

    @action.bound
    setItem(payment: Payment | null): void {
        this.item = payment
    }

    @computed
    get getItem(): Payment | null {
        return toJS(this.item)
    }

    @action.bound
    setCreatePaymentQuestionnaireModel(createPaymentQuestionnaireModel: CreatePaymentQuestionnaireModel | null): void {
        this.createPaymentQuestionnaireModel = createPaymentQuestionnaireModel
    }

    @computed
    get getCreatePaymentQuestionnaireModel(): CreatePaymentQuestionnaireModel | null {
        return this.createPaymentQuestionnaireModel
    }

    @action.bound
    updateCreatePaymentDescription(description: string) {
        if (!this.createPaymentQuestionnaireModel) {
            return
        }
        this.createPaymentQuestionnaireModel['createPaymentRequest']['description'] = description
    }

    @action.bound
    setPageCountAll(pageCount: number) {
        this.pageCount = pageCount
    }

    @computed
    get getPageCount() {
        return toJS(this.pageCount)
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/PaymentsStore.ts